import NavigateButton from "./NavigateButton.component.jsx";

export default NavigateButton;